export default "__VITE_ASSET__7d1778b6__"